module.exports = __webpack_public_path__ + "img/gelentjik@2x.20ce9980.png";